const defaultState = {
    count: 0,
}

const ADD_CASH = "ADD_CASH";
const REMOVE_CASH = "REMOVE_CASH";
const RETURN_CASH = "RETURN_CASH";

export const cashReducer = (state = defaultState, action) => {
    switch(action.type) {
        case ADD_CASH:
            return {...state, count: state.count + action.payload}
        case REMOVE_CASH:
            return {...state, count: state.count - action.payload}
        case RETURN_CASH:
            return {...state, count: state.count = 0}
        default:
            return state;
    }
}

export const addCashAction = (payload) => ({type: ADD_CASH, payload});
export const removeCashAction = (payload) => ({type: REMOVE_CASH, payload});
export const returnCashAction = (payload) => ({type: RETURN_CASH, payload});

